import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturaFicheiros = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/viaturaFicheiros`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURA_FICHEIROS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturaFicheiros;
